export const siteContent = {
  tr: {
    languageName: 'Türkçe',
    languageShort: 'TR',
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      services: 'Hizmetler',
      analyses: 'Jeopolitik Analizler',
      research: 'Lojistik Araştırmaları',
      media: 'Medya & Basın',
      lifestyle: 'Yaşam Stili',
      blog: 'Blog / İçgörüler',
      references: 'Referanslar',
      contact: 'İletişim',
    },
    common: {
      readMore: 'Devamını oku',
      explore: 'İncele',
      contact: 'İletişime geç',
      allInsights: 'Tüm içerikleri gör',
      viewServices: 'Hizmetleri incele',
      backToBlog: 'Bloga dön',
      latestInsights: 'Son içerikler',
      availableOnRequest: 'Detaylı referanslar talep üzerine paylaşılabilir.',
    },
    hero: {
      eyebrow: '30+ yıllık saha ve yönetim deneyimi',
      name: 'Gürkan Kavrazlı',
      title: 'Uluslararası Lojistik Stratejisti',
      roles: 'Yazar · Eğitmen · Danışman · Konuşmacı',
      statement: 'Küresel lojistiği; strateji, saha deneyimi ve insan odaklı liderlikle dönüştürüyorum.',
      body: 'Tedarik zinciri, depo ve operasyon yönetimi, uluslararası ticaret, afet lojistiği ve sürdürülebilir dönüşüm alanlarında kurumlara uygulanabilir stratejiler sunuyorum.',
      primaryCta: 'Birlikte çalışalım',
      secondaryCta: 'Uzmanlık alanlarım',
      imageAlt: 'Gürkan Kavrazlı profesyonel portre',
      badge: 'Bilgiyi değere, deneyimi etkiye dönüştürmek',
    },
    identities: [
      'Uluslararası Lojistik Uzmanı',
      'Supply Chain & Commodity Trading Danışmanı',
      'Jeopolitik Analist',
      'Eğitmen',
      'Yazar',
      'Konuşmacı',
      'Entegratör',
    ],
    about: {
      eyebrow: 'Hakkımda',
      title: '30 Yıllık Deneyim, Bilgiyi Değere Dönüştüren Bir Yolculuk',
      short: 'Yaklaşık 30 yıllık lojistik, tedarik zinciri ve operasyon yönetimi deneyimim boyunca ulusal ve uluslararası birçok organizasyonda yöneticilik yaptım; stratejik planlamadan depo ve dağıtım operasyonlarına, süreç iyileştirmeden performans yönetimine, sürdürülebilirlikten afet lojistiğine kadar sektörün birçok kritik alanında projeler geliştirdim ve yönettim.',
      paragraphs: [
        'Bugün bilgi ve deneyimimi yalnızca danışmanlık hizmeti sunarak değil; eğitimler, konferanslar, akademik çalışmalar, sektör yayınları ve dijital içerikler aracılığıyla da paylaşmayı sürdürüyorum. Üniversiteler, kurumlar ve profesyonellerle gerçekleştirdiğim çalışmaların temel amacı; lojistik sektörüne sürdürülebilir değer kazandırmak, yeni nesil profesyonellerin gelişimine katkı sağlamak ve sektörün dönüşümüne liderlik etmektir.',
        'Lojistik, tedarik zinciri yönetimi, depo ve operasyon yönetimi, uluslararası ticaret, afet lojistiği, insani yardım lojistiği ve sürdürülebilir lojistik alanlarında kurumlara stratejik danışmanlık, eğitim ve proje geliştirme desteği sunuyor; aynı zamanda genç profesyonellere gönüllü mentörlük yaparak bilgi paylaşımını sosyal sorumluluğun ayrılmaz bir parçası olarak görüyorum.',
        'Mesleki yaklaşımım; etik değerler, güven, sürdürülebilir gelişim, insan odaklı liderlik ve sürekli öğrenme üzerine kuruludur. Çünkü inanıyorum ki güçlü organizasyonlar, güçlü süreçlerden; güçlü süreçler ise doğru bilgi ve deneyimi paylaşan insanlardan doğar.',
        'Bugün de aynı heyecanla kurumların dönüşümüne katkı sağlamaya, sektörün geleceğine değer katmaya ve bilgi birikimimi yeni nesillere aktarmaya devam ediyorum.',
      ],
      quote: 'Bilginin paylaşıldıkça çoğaldığına, deneyimin ise paylaşıldıkça değer kazandığına inanıyorum.',
      values: [
        { title: 'Etik ve Güven', text: 'Kalıcı sonuçların şeffaflık, sorumluluk ve güven üzerine kurulduğuna inanıyorum.' },
        { title: 'Saha Gerçekliği', text: 'Stratejiyi operasyonun gerçek koşullarıyla buluşturan uygulanabilir çözümler geliştiriyorum.' },
        { title: 'İnsan Odaklı Liderlik', text: 'Süreçlerin başarısını, onları sahiplenen ve geliştiren insanların gücüyle birlikte ele alıyorum.' },
        { title: 'Sürekli Öğrenme', text: 'Bilgiyi güncel tutuyor, deneyimi eğitim, yayın ve mentörlük yoluyla çoğaltıyorum.' },
      ],
    },
    stats: [
      { key: 'people_trained', value: '3K+', label: 'Eğitim verilen kişi sayısı' },
      { key: 'experience_years', value: '30+', label: 'Yıllık profesyonel deneyim' },
      { key: 'project_management', value: '10+', label: 'Proje yönetimi' },
      { key: 'industries', value: '6+', label: 'Farklı sektörde operasyon bilgisi' },
      { key: 'events', value: '50+', label: 'Konferans, seminer ve eğitim katkısı' },
    ],
    services: {
      eyebrow: 'Uzmanlıklar ve Eğitimler',
      title: 'Stratejiden sahaya, uçtan uca lojistik değer üretimi',
      intro: 'Her çalışma; mevcut durumun net analizi, ölçülebilir hedefler ve sahada uygulanabilir bir yol haritası üzerine kurulur.',
      items: [
        {
          icon: 'Route',
          title: 'Lojistik ve Tedarik Zinciri Stratejisi',
          text: 'Tedarik zinciri haritalama, ağ tasarımı, akış optimizasyonu, operasyon stratejisi ve karar destek çalışmaları.',
          bullets: ['Mevcut durum analizi', 'Ağ ve süreç tasarımı', 'KPI ve performans modeli'],
        },
        {
          icon: 'Warehouse',
          title: 'Depo, Envanter ve Operasyon Yönetimi',
          text: 'Yeni depo kurulumu, depo süreçleri, WMS/ERP geçişleri, envanter optimizasyonu ve operasyonel verimlilik.',
          bullets: ['Depo tasarımı ve devreye alma', 'Stok doğruluğu ve optimizasyon', 'WMS/ERP süreç entegrasyonu'],
        },
        {
          icon: 'Globe2',
          title: 'Uluslararası Ticaret ve Gümrük',
          text: 'İthalat-ihracat akışları, gümrüklü antrepo yönetimi, taşıma organizasyonu ve sınır ötesi operasyonlar.',
          bullets: ['Gümrük prosedürleri', 'Gümrüklü depo yönetimi', 'İthalat ve ihracat süreçleri'],
        },
        {
          icon: 'BarChart3',
          title: 'Maliyet, 3PL ve Performans Yönetimi',
          text: 'Maliyet analizi, bütçe, 3PL sözleşme ve hizmet seviyesi yönetimi ile ölçülebilir verimlilik programları.',
          bullets: ['Maliyet ve değer analizi', '3PL sözleşme yönetimi', 'SLA/KPI performans takibi'],
        },
        {
          icon: 'BriefcaseBusiness',
          title: 'Proje ve İş Geliştirme',
          text: 'Yeni müşteri başlangıçları, stratejik projeler, süreç iyileştirme ve farklı paydaşların entegrasyonu.',
          bullets: ['Yeni iş başlangıç projeleri', 'Süreç iyileştirme', 'Paydaş ve değişim yönetimi'],
        },
        {
          icon: 'GraduationCap',
          title: 'Eğitim, Mentörlük ve Konuşmacılık',
          text: 'Kurumlara, üniversitelere ve profesyonellere özel eğitimler, konferanslar ve kariyer gelişimi programları.',
          bullets: ['Kuruma özel eğitim', 'Konferans ve keynote', 'Gönüllü mentörlük'],
        },
        {
          icon: 'ShieldCheck',
          title: 'Afet Lojistiği ve İnsani Yardım',
          text: 'Afet hazırlığı, operasyonel dayanıklılık, insani yardım akışları ve sürdürülebilir lojistik yaklaşımı.',
          bullets: ['Afet lojistiği planlama', 'İş sürekliliği', 'Dayanıklılık ve sürdürülebilirlik'],
        },
        {
          icon: 'Leaf',
          title: 'Yeşil Lojistik',
          text: 'Lojistik operasyonların çevresel etkisini azaltan, kaynak kullanımını iyileştiren ve sürdürülebilir değer üreten dönüşüm çalışmaları.',
          bullets: ['Karbon ayak izi ve emisyon azaltımı', 'Enerji ve kaynak verimliliği', 'Sürdürülebilir operasyon yol haritası'],
        },
        {
          icon: 'PackageSearch',
          title: 'Commodity Trading ve Jeopolitik Analiz',
          text: 'Emtia akışlarını, ticaret koridorlarını ve jeopolitik riskleri lojistik perspektifiyle değerlendiren analizler.',
          bullets: ['Ticaret koridorları', 'Risk ve senaryo analizi', 'Emtia akışı değerlendirmesi'],
        },
      ],
      training: {
        eyebrow: 'Kurumsal ve bireysel eğitimler',
        title: 'Eğitim Programları',
        intro: 'Saha deneyimine dayalı, kurumların ve profesyonellerin ihtiyaçlarına göre yapılandırılabilen eğitim başlıkları.',
        items: [
          'Stok Yönetimi',
          'Depo Yönetimi',
          'Depo Yönetim Sistemleri',
          'Depo Süreçleri & Operasyonel Verimlilik',
          'Doğru Stok, Envanter Yönetimi ve Sayımlar',
          'Forklift Kullanım Kuralları',
          'Kurum Stratejilerini Anlama',
          'INCOTERMS 2020',
          'Lojistik Yönetiminde Liderlik',
          'Etki(n) Etkili Takım Kurma & Takım Yönetimi',
          '5S Uygulama Eğitimi',
          'Uluslararası Ticarette Ödeme Şekilleri',
        ],
        distribution: {
          eyebrow: 'Eğitim odağı',
          title: 'Eğitimlerin Sektörel Dağılımı',
          intro: 'Eğitim deneyiminin sektörlere göre dağılımı; depo, sevkiyat ve operasyon ihtiyaçlarının ağırlığını gösterir.',
          items: [
            { label: 'UND', value: 50 },
            { label: 'Depolama', value: 30 },
            { label: 'Otomotiv Depo', value: 15 },
            { label: 'Sağlık Depo', value: 5 },
          ],
        },
      },
    },
    experience: {
      eyebrow: 'Kariyer yolculuğu',
      title: 'Operasyonun içinden gelen stratejik liderlik',
      items: [
        {
          period: '2019 — Günümüz',
          title: 'Strateji, operasyon, satış ve düşünce liderliği',
          organization: 'Göktürk Lojistik · LogiRED · Loji TV · Bağımsız çalışmalar',
          text: 'Depo ve lojistik yönetimi, satış ve pazarlama liderliği, strateji ve operasyon direktörlüğü; danışmanlık, eğitim, yazarlık ve konuşmacılık çalışmaları.',
        },
        {
          period: '2012 — 2019',
          title: 'Lojistik Merkezi ve Operasyon Müdürü',
          organization: 'İstanbul',
          text: 'Gümrüklü antrepo, ilaç ve hammadde akışları, depo ve taşıma operasyonları, 3PL yönetimi, HSSE, KPI ve süreç iyileştirme sorumlulukları.',
        },
        {
          period: '2011 — 2012',
          title: 'Lojistik Depo ve Operasyon Müdürü',
          organization: 'Tatko — Tatkap A.Ş.',
          text: 'Depo yönetimi, bütçe, tedarikçi, dağıtım, ihracat süreçleri, MİKRO otomasyon ve operasyonel verimlilik çalışmaları.',
        },
        {
          period: '2007 — 2010',
          title: 'Gümrüklü ve Gümrüksüz Depo Müdürü',
          organization: 'Horoz Lojistik A.Ş.',
          text: 'Depo, gümrük, müşteri, bütçe, dağıtım, tedarik zinciri, WMS LV3 ve envanter optimizasyonu yönetimi.',
        },
        {
          period: '2007',
          title: 'Operasyon Müdürü — Konya Projesi',
          organization: 'Borusan Lojistik',
          text: 'Eksiklerin analizi, süreç ve standartların kurulması, personel eğitimi, müşteri memnuniyeti ve operasyon devri.',
        },
        {
          period: '2001 — 2007',
          title: 'Lojistik Depo ve Operasyon Müdürü',
          organization: 'Rynart Uluslararası Nakliyat A.Ş.',
          text: 'ISO, HACCP, VAS, stok ve sipariş operasyonları, ithalat-ihracat, gümrüklü depo ve dağıtım yönetimi.',
        },
        {
          period: '1995 — 1999',
          title: 'Lojistik Depo Sorumlusu',
          organization: 'Arena Bilgisayar A.Ş.',
          text: 'Yeni depo ve iş başlangıç projeleri, ithalat-ihracat, sipariş, stok, dağıtım, ekip eğitimi ve motivasyon.',
        },
      ],
    },
    analyses: {
      eyebrow: 'Jeopolitik analizler',
      title: 'Küresel gelişmeleri lojistik ve ticaret akışları üzerinden okumak',
      intro: 'Malların, enerjinin, sermayenin ve bilginin dünya üzerindeki hareketini analiz ederek jeopolitik, ekonomik ve stratejik dönüşümleri bütüncül bir bakış açısıyla anlamaktır.',
      topics: [
        { title: 'Ticaret Koridorları', text: 'Deniz, kara, hava ve demiryolu ağlarında değişen koridorların operasyonel ve ekonomik etkileri.' },
        { title: 'Bölgesel Riskler', text: 'Siyasi, güvenlik ve iklim kaynaklı risklerin rota, kapasite ve hizmet sürekliliğine etkisi.' },
        { title: 'Enerji ve Emtia Akışları', text: 'Emtia piyasaları ile taşıma kapasitesi, stok stratejisi ve uluslararası ticaret arasındaki bağlantılar.' },
        { title: 'Afetler ve Dayanıklılık', text: 'Afetlerin lojistik altyapıya etkisi; hazırlık, alternatif ağ ve hızlı koordinasyon senaryoları.' },
      ],
    },
    research: {
      eyebrow: 'Lojistik araştırmaları',
      title: 'Sahadan gelen soruları ölçülebilir bilgiye dönüştürmek',
      intro: 'Araştırma gündemim; kurumların gerçek operasyonel problemlerine, yeni nesil lojistik uygulamalarına ve sektörün dönüşüm ihtiyacına odaklanır.',
      topics: [
        { title: 'Depo ve Envanter', text: 'Stok doğruluğu, yerleşim, kapasite, sipariş hazırlama ve depo performans modelleri.' },
        { title: 'Dijitalleşme ve Otomasyon', text: 'WMS, ERP, veri akışı, otomasyon ve karar destek sistemlerinin sahadaki karşılığı.' },
        { title: 'Maliyet ve Verimlilik', text: 'Toplam maliyet, hizmet seviyesi, kaynak kullanımı ve operasyonel değer üretimi.' },
        { title: 'Sürdürülebilir Lojistik', text: 'Çevresel etki, kaynak verimliliği ve uzun vadeli operasyonel dayanıklılık.' },
      ],
      bookTitle: 'Lojistik Faaliyetlerde Çözümlü Vaka Analizleri',
      bookText: 'Gerçek operasyon mantığını örnek olaylarla ele alan, lojistik problemlerini analiz ve çözüm adımlarıyla değerlendiren çalışma.',
    },
    media: {
      eyebrow: 'Medya ve basın',
      title: 'Bilgiyi sahnede, ekranda ve dijital kanallarda paylaşmak',
      intro: 'Konferans, panel, televizyon yayını, üniversite buluşmaları ve dijital içerikler aracılığıyla lojistik bilgisinin daha geniş kitlelere ulaşmasına katkı sağlıyorum.',
      events: [
        {
          date: '2026',
          title: 'Afetlerde Engelli Bireylerin Durumu ve İstanbul Depremi',
          place: 'Beykent Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2026-beykent-afetlerde-engelli-bireyler.png',
          imageAlt: 'Beykent Üniversitesinde afetlerde engelli bireylerin durumu ve İstanbul depremi sunumu',
        },
        {
          date: '2026',
          title: 'Lojistik Atölye Açılışı',
          place: 'Soma Fatih MTAL — Manisa',
          role: 'Davetli',
          image: '/images/events/2026-soma-fatih-mtal-lojistik-atolye-acilisi.png',
          imageAlt: 'Soma Fatih Mesleki ve Teknik Anadolu Lisesi lojistik atölye açılışı',
        },
        {
          date: '2026',
          title: 'Davutpaşa Kampüsü Buluşması',
          place: 'Yıldız Teknik Üniversitesi — İstanbul',
          role: 'Katılımcı',
          image: '/images/events/2026-yildiz-teknik-davutpasa.png',
          imageAlt: 'Yıldız Teknik Üniversitesi Davutpaşa Kampüsü buluşması',
        },
        {
          date: '2026',
          title: 'Beykent Üniversitesi Buluşması',
          place: 'Beykent Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2026-beykent-universitesi-bulusmasi.png',
          imageAlt: 'Beykent Üniversitesinde Gürkan Kavrazlı sunum yaparken',
        },
        {
          date: '2025',
          title: 'İstanbul Kent Üniversitesi Buluşması',
          place: 'İstanbul Kent Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2025-istanbul-kent-universitesi.png',
          imageAlt: 'İstanbul Kent Üniversitesi etkinliği ve katılımcıları',
        },
        {
          date: '2025',
          title: 'Sürdürülebilirlik ve Yeşil Lojistik Faaliyetleri',
          place: 'Beykent Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2025-beykent-surdurulebilirlik-yesil-lojistik.png',
          imageAlt: 'Beykent Üniversitesi sürdürülebilirlik ve yeşil lojistik etkinliği',
        },
        {
          date: '2025',
          title: 'Soma Fatih MTAL Buluşması',
          place: 'Soma Fatih MTAL — Manisa',
          role: 'Konuşmacı',
          image: '/images/events/2025-soma-fatih-mtal-bulusmasi.png',
          imageAlt: 'Soma Fatih Mesleki ve Teknik Anadolu Lisesi buluşması',
        },
        {
          date: '2025',
          title: 'Göktürk Lojistik Workshop',
          place: 'Göktürk Lojistik — İstanbul',
          role: 'Eğitmen',
          image: '/images/events/2025-gokturk-lojistik-workshop.png',
          imageAlt: 'Göktürk Lojistik workshop katılımcıları',
        },
        {
          date: '2024',
          title: 'Automechanika İstanbul',
          place: 'TÜYAP Fuar ve Kongre Merkezi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2024-automechanika-tuyap.png',
          imageAlt: 'Automechanika İstanbul etkinliğinde Gürkan Kavrazlı sunum yaparken',
        },
        {
          date: 'Mayıs 2024',
          title: 'Lojistik Sohbetleri Instagram Canlı Yayını',
          place: 'Halit Kaya ile Instagram canlı yayını',
          role: 'Konuk',
          image: '/images/events/2024-halit-kaya-instagram-canli.png',
          imageAlt: 'Gürkan Kavrazlı ve Halit Kaya Lojistik Sohbetleri Instagram canlı yayın duyurusu',
          category: 'online',
          sortDate: '2024-05-31',
        },
        {
          date: '2024',
          title: 'Kansersiz Yaşam Derneği Etkinliği',
          place: 'KüçükÇiftlik Park — İstanbul',
          role: 'Katılımcı',
          image: '/images/events/2024-kansersiz-yasam-dernegi.png',
          imageAlt: 'Kansersiz Yaşam Derneği KüçükÇiftlik Park etkinliği',
        },
        {
          date: '2023',
          title: 'Denizci Öğrenciler Derneği Buluşması',
          place: 'Denizci Öğrenciler Derneği — Antalya',
          role: 'Konuşmacı',
          image: '/images/events/2023-denizci-ogrenciler-dernegi-antalya.png',
          imageAlt: 'Denizci Öğrenciler Derneği Antalya buluşması',
        },
        {
          date: '2023',
          title: 'Afet Lojistiği',
          place: 'Logitrans Fuarı — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2023-logitrans-afet-lojistigi.png',
          imageAlt: 'Logitrans Fuarında afet lojistiği oturumu',
        },
        {
          date: '2023',
          title: 'Beykent Üniversitesi Buluşması',
          place: 'Beykent Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2023-beykent-universitesi-bulusmasi.png',
          imageAlt: 'Beykent Üniversitesi buluşması katılımcıları',
        },
        {
          date: 'Mayıs 2022',
          title: 'Lojistikte Yeni Trendler',
          place: 'Beykent Üniversitesi Hadımköy Yerleşkesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2022-beykent-lojistikte-yeni-trendler.png',
          imageAlt: 'Beykent Üniversitesi Lojistikte Yeni Trendler etkinliği duyurusu',
          category: 'online',
          sortDate: '2022-05-18',
        },
        {
          date: 'Mart 2022',
          title: 'Emerging Trends in Management',
          place: 'Manipal University Jaipur — Çevrim içi',
          role: 'Konuşmacı',
          image: '/images/events/2022-manipal-university-emerging-trends.png',
          imageAlt: 'Manipal University Jaipur Emerging Trends in Management etkinliği konuşmacıları',
          category: 'online',
          sortDate: '2022-03-24',
        },
        {
          date: 'Mart 2022',
          title: '1 Kahve 1 Lojistik: Depo ve Stok Yönetimi',
          place: 'LogiRED — Maltepe, İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2022-logired-bir-kahve-bir-lojistik.png',
          imageAlt: '1 Kahve 1 Lojistik Depo ve Stok Yönetimi etkinliği duyurusu',
          category: 'online',
          sortDate: '2022-03-03',
        },
        {
          date: '2022',
          title: 'Yaşar Üniversitesi Çevrim İçi Buluşması',
          place: 'Yaşar Üniversitesi — Çevrim içi',
          role: 'Konuşmacı',
          image: '/images/events/2022-yasar-universitesi-online.png',
          imageAlt: 'Yaşar Üniversitesi çevrim içi lojistik buluşması',
          category: 'online',
          sortDate: '2022-01-01',
        },
        {
          date: '2021',
          title: 'Genç UND Akademi 1. Mezuniyet Töreni',
          place: 'İstanbul Üniversitesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2021-genc-und-akademi-mezuniyet.png',
          imageAlt: 'Genç UND Akademi birinci mezuniyet töreni',
        },
        {
          date: 'Nisan 2020',
          title: 'Lojistik Topluluğu Instagram Canlı Yayını',
          place: 'Bandırma Onyedi Eylül Üniversitesi — Çevrim içi',
          role: 'Konuşmacı',
          image: '/images/events/2020-bandirma-instagram-canli-yayin.png',
          imageAlt: 'Bandırma Onyedi Eylül Üniversitesi Lojistik Topluluğu Instagram canlı yayın duyurusu',
          category: 'online',
          sortDate: '2020-04-06',
        },
        {
          date: '2020',
          title: 'Lojistikte Yeni Trendler',
          place: 'Bandırma Onyedi Eylül Üniversitesi — Balıkesir',
          role: 'Konuşmacı',
          image: '/images/events/2020-bandirma-onyedi-eylul-bulusmasi.png',
          imageAlt: 'Bandırma Onyedi Eylül Üniversitesinde lojistik sunumu',
        },
        {
          date: 'Ocak 2020',
          title: 'Lider Vaka Yöneticisi Workshop',
          place: 'Congar Hukuk & Danışmanlık — İstanbul',
          role: 'Katılımcı',
          image: '/images/events/2020-lider-vaka-yoneticisi-workshop.jpeg',
          imageAlt: 'Lider Vaka Yöneticisi Workshop buluşmasında Gürkan Kavrazlı ve katılımcı',
        },
        {
          date: 'Aralık 2019',
          title: 'Lojistik Zirvesi',
          place: 'Abidin Nesimi Fatinoğlu Anadolu Lisesi — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2019-anfa-lojistik-zirvesi.jpg',
          imageAlt: 'Abidin Nesimi Fatinoğlu Anadolu Lisesi Lojistik Zirvesi katılımcı fotoğrafı',
        },
        {
          date: '2019',
          title: 'KLU Uygulamalı Bilimler Fakültesi Buluşması',
          place: 'Kırklareli Üniversitesi — Kırklareli',
          role: 'Konuşmacı',
          image: '/images/events/2019-klu-uygulamali-bilimler.png',
          imageAlt: 'Kırklareli Üniversitesi Uygulamalı Bilimler Fakültesi buluşması',
        },
        {
          date: '2019',
          title: 'Akdeniz Üniversitesi Buluşması',
          place: 'Akdeniz Üniversitesi — Antalya',
          role: 'Konuşmacı',
          image: '/images/events/2019-akdeniz-universitesi.png',
          imageAlt: 'Akdeniz Üniversitesi etkinliği katılımcıları',
        },
        {
          date: '2019',
          title: '3. InTraders Uluslararası Ticaret Kongresi',
          place: 'Sakarya Üniversitesi — Sakarya',
          role: 'Konuşmacı',
          image: '/images/events/2019-intraders-international-conference.png',
          imageAlt: 'Üçüncü InTraders Uluslararası Ticaret Kongresinde Gürkan Kavrazlı',
        },
        {
          date: '2019',
          title: 'Afyon Kocatepe Üniversitesi Buluşması',
          place: 'Afyon Kocatepe Üniversitesi — Afyonkarahisar',
          role: 'Konuşmacı',
          image: '/images/events/2019-afyon-kocatepe-universitesi.png',
          imageAlt: 'Afyon Kocatepe Üniversitesi etkinliği katılımcıları',
        },
        {
          date: 'Nisan 2019',
          title: '3. Kariyer Günleri',
          place: 'Recep Tayyip Erdoğan Üniversitesi — Rize',
          role: 'Konuşmacı',
          image: '/images/events/2019-3-kariyer-gunleri-rize.jpg',
          imageAlt: 'Recep Tayyip Erdoğan Üniversitesi 3. Kariyer Günleri grup fotoğrafı',
        },
        {
          date: 'Nisan 2019',
          title: 'İŞKOLİK TV Programı',
          place: 'Business Channel — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2019-iskolik-tv-business-channel.jpeg',
          imageAlt: 'Business Channel İŞKOLİK TV Programı etkinlik ve sertifika fotoğrafı',
        },
        {
          date: 'Nisan 2019',
          title: 'Konya Lojistik Zirvesi',
          place: 'Necmettin Erbakan Üniversitesi — Konya',
          role: 'Konuşmacı',
          image: '/images/events/2019-konya-lojistik-zirvesi.jpeg',
          imageAlt: 'Necmettin Erbakan Üniversitesi Konya Lojistik Zirvesi sahne fotoğrafı',
        },
        {
          date: 'Mart 2019',
          title: 'Duayenlerden Mesleki Taktikler III',
          place: 'Çağ Üniversitesi — Mersin',
          role: 'Konuşmacı',
          image: '/images/events/2019-cag-universitesi-duayenlerden-mesleki-taktikler.jpeg',
          imageAlt: 'Çağ Üniversitesi Duayenlerden Mesleki Taktikler III etkinliğinde Gürkan Kavrazlı sunum yaparken',
        },
        {
          date: 'Nisan 2018',
          title: 'Uluslararası Lojistik Yönetimi ve Kariyer Planlaması',
          place: 'Beykent Üniversitesi — İstanbul',
          role: 'Panelist / Konuşmacı',
          image: '/images/events/2018-uluslararasi-lojistik-yonetimi-kariyer-planlamasi.jpeg',
          imageAlt: 'Uluslararası Lojistik Yönetimi ve Kariyer Planlaması etkinliğinde Gürkan Kavrazlı sunum yaparken',
        },
        {
          date: '2016',
          title: 'Samandıra MTAL Lojistik Buluşması',
          place: 'Samandıra MTAL — İstanbul',
          role: 'Konuşmacı',
          image: '/images/events/2016-samandira-mtal.png',
          imageAlt: 'Samandıra Mesleki ve Teknik Anadolu Lisesi lojistik buluşması',
        },
      ],
    },
    lifestyle: {
      eyebrow: 'Yaşam Stili',
      title: 'Yaşamdan Kesitler',
      intro: 'Yaşam stili içerikleri, deneyimler ve kişisel paylaşımlar bu sayfada yer alacak.',
      comingSoon: 'Yeni içerikler yakında burada.',
    },
    references: {
      eyebrow: 'Referanslar ve sektör deneyimi',
      title: 'Farklı sektörlerin farklı operasyon gerçeklikleriyle çalıştım',
      intro: 'Deneyim; yalnızca yıl sayısı değil, farklı ürün, müşteri ve hizmet modellerini anlayıp doğru sisteme dönüştürebilme becerisidir.',
      organizationsTitle: 'Kurum ve Eğitim Referansları',
      organizationsIntro: 'Danışmanlık, eğitim, iş birliği ve sektörel çalışmalar kapsamında temas edilen kurum ve markalar.',
      sectors: [
        'Otomotiv',
        'Dayanıklı Tüketim Ürünleri',
        'İlaç ve Eczacılık',
        'Yüksek Teknoloji Malzemeleri',
        'Dokusuz Ürünler',
        'Tıbbi Cihazlar',
        'Bilgisayar ve Teknoloji',
        'Uluslararası Taşımacılık',
      ],
      standards: ['ISO 9001', 'ISO 14001', 'HACCP', 'TAPA', '5S', 'POP', 'HSSE', '6 Sigma'],
    },
    socialResponsibility: {
      eyebrow: 'Sosyal sorumluluk',
      title: 'Bilgi paylaşımını mesleki sorumluluğun bir parçası görüyorum',
      items: [
        'Meslek liseleri ve üniversitelerde öğrencilerle gönüllü buluşmalar',
        'Gönüllü CV danışmanlığı, staj ve iş yeri bulma desteği',
        'Üniversite öğrencileri, yeni mezunlar ve profesyoneller için mentörlük',
        'Yüksek lisans ve doktora tez koçluğu',
        'AKUT, AFAD ve MAG AME gönüllülüğüyle afet bilincine katkı',
      ],
    },
    contact: {
      eyebrow: 'İletişim',
      title: 'Bir proje, eğitim veya konuşma için bağlantı kuralım',
      intro: 'İhtiyacınızı kısaca paylaşın. Mesajınız güvenli iletişim merkezi üzerinden doğrudan bana ulaşsın.',
      email: 'gurkankavrazli@gmail.com',
      phone: '+90 542 315 7098',
      location: 'İstanbul, Türkiye',
      form: {
        name: 'Ad Soyad',
        email: 'E-posta',
        company: 'Kurum / Şirket',
        subject: 'Konu',
        message: 'Mesajınız',
        consent: 'İletişim amacıyla paylaştığım bilgilerin işlenmesini kabul ediyorum.',
        submit: 'Mesajı gönder',
        sending: 'Gönderiliyor…',
        success: 'Mesajınız başarıyla gönderildi. En kısa sürede dönüş yapılacaktır.',
        error: 'Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin veya doğrudan e-posta gönderin.',
      },
    },
    blog: {
      eyebrow: 'Blog / İçgörüler',
      title: 'Lojistik, tedarik zinciri ve küresel ticarete dair notlar',
      intro: 'Sahadan gözlemler, araştırma makaleleri, etkinlik içerikleri ve stratejik değerlendirmeler.',
      empty: 'Henüz yayınlanmış bir içerik bulunmuyor.',
      fallbackNotice: 'Aşağıdaki içerikler, Supabase bağlantısı kurulana kadar gösterilen tanıtım içerikleridir.',
      categories: { all: 'Tümü' },
    },
    footer: {
      statement: 'Strateji, operasyon ve bilgi paylaşımıyla lojistiğin geleceğine değer katmak.',
      rights: 'Tüm hakları saklıdır.',
      admin: 'Admin girişi',
    },
  },
  en: {
    languageName: 'English',
    languageShort: 'EN',
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      analyses: 'Geopolitical Analyses',
      research: 'Logistics Research',
      media: 'Media & Press',
      lifestyle: 'Lifestyle',
      blog: 'Blog / Insights',
      references: 'References',
      contact: 'Contact',
    },
    common: {
      readMore: 'Read more',
      explore: 'Explore',
      contact: 'Get in touch',
      allInsights: 'View all insights',
      viewServices: 'Explore services',
      backToBlog: 'Back to blog',
      latestInsights: 'Latest insights',
      availableOnRequest: 'Detailed references are available upon request.',
    },
    hero: {
      eyebrow: '30+ years of field and leadership experience',
      name: 'Gürkan Kavrazlı',
      title: 'International Logistics Strategist',
      roles: 'Author · Trainer · Consultant · Speaker',
      statement: 'Transforming global logistics through strategy, field experience and people-centered leadership.',
      body: 'I provide practical strategies in supply chain, warehouse and operations management, international trade, disaster logistics and sustainable transformation.',
      primaryCta: 'Let’s work together',
      secondaryCta: 'Explore expertise',
      imageAlt: 'Professional portrait of Gürkan Kavrazlı',
      badge: 'Turning knowledge into value and experience into impact',
    },
    identities: [
      'International Logistics Expert',
      'Supply Chain & Commodity Trading Consultant',
      'Geopolitical Analyst',
      'Trainer',
      'Author',
      'Speaker',
      'Integrator',
    ],
    about: {
      eyebrow: 'About',
      title: '30 Years of Experience, A Journey That Turns Knowledge into Value',
      short: 'Throughout nearly 30 years in logistics, supply chain and operations management, I have led national and international organizations and managed projects across strategic planning, warehousing, distribution, process improvement, performance, sustainability and disaster logistics.',
      paragraphs: [
        'Today, I share my knowledge not only through consulting, but also through training, conferences, academic work, industry publications and digital content. My goal is to create sustainable value for the logistics sector, support the development of a new generation of professionals and contribute to industry transformation.',
        'I provide strategic consulting, training and project development support in logistics, supply chain management, warehouse and operations management, international trade, disaster logistics, humanitarian logistics and sustainable logistics. I also view voluntary mentoring as an essential part of professional responsibility.',
        'My professional approach is built on ethics, trust, sustainable development, people-centered leadership and continuous learning. Strong organizations are created by strong processes, and strong processes are created by people who share the right knowledge and experience.',
        'I continue to support organizational transformation, add value to the future of the sector and transfer my experience to new generations with the same enthusiasm.',
      ],
      quote: 'I believe knowledge grows when it is shared, and experience becomes more valuable when it is passed on.',
      values: [
        { title: 'Ethics and Trust', text: 'Lasting results are built on transparency, accountability and trust.' },
        { title: 'Field Reality', text: 'I connect strategy with real operating conditions to develop practical solutions.' },
        { title: 'People-Centered Leadership', text: 'I treat people who own and improve processes as the core of sustainable performance.' },
        { title: 'Continuous Learning', text: 'I keep knowledge current and multiply experience through training, publishing and mentoring.' },
      ],
    },
    stats: [
      { key: 'people_trained', value: '3K+', label: 'People trained' },
      { key: 'experience_years', value: '30+', label: 'Years of professional experience' },
      { key: 'project_management', value: '10+', label: 'Project management' },
      { key: 'industries', value: '6+', label: 'Industries with operational experience' },
      { key: 'events', value: '50+', label: 'Conference, seminar and training contributions' },
    ],
    services: {
      eyebrow: 'Services and expertise',
      title: 'End-to-end logistics value, from strategy to execution',
      intro: 'Every engagement is structured around a clear current-state assessment, measurable goals and a practical implementation roadmap.',
      items: [
        { icon: 'Route', title: 'Logistics & Supply Chain Strategy', text: 'Supply chain mapping, network design, flow optimization, operating strategy and decision support.', bullets: ['Current-state assessment', 'Network and process design', 'KPI and performance model'] },
        { icon: 'Warehouse', title: 'Warehouse, Inventory & Operations', text: 'New warehouse setup, warehouse processes, WMS/ERP transitions, inventory optimization and operational efficiency.', bullets: ['Warehouse design and launch', 'Inventory accuracy and optimization', 'WMS/ERP process integration'] },
        { icon: 'Globe2', title: 'International Trade & Customs', text: 'Import-export flows, bonded warehouse management, transport organization and cross-border operations.', bullets: ['Customs procedures', 'Bonded warehouse management', 'Import and export processes'] },
        { icon: 'BarChart3', title: 'Cost, 3PL & Performance Management', text: 'Cost analysis, budgeting, 3PL contracting, service levels and measurable efficiency programs.', bullets: ['Cost and value analysis', '3PL contract management', 'SLA/KPI performance tracking'] },
        { icon: 'BriefcaseBusiness', title: 'Projects & Business Development', text: 'New customer launches, strategic projects, process improvement and stakeholder integration.', bullets: ['New business launches', 'Process improvement', 'Stakeholder and change management'] },
        { icon: 'GraduationCap', title: 'Training, Mentoring & Speaking', text: 'Tailored programs, conferences and career development sessions for companies, universities and professionals.', bullets: ['Tailored corporate training', 'Conference and keynote', 'Voluntary mentoring'] },
        { icon: 'ShieldCheck', title: 'Disaster Logistics & Humanitarian Aid', text: 'Preparedness, operational resilience, humanitarian flows and sustainable logistics.', bullets: ['Disaster logistics planning', 'Business continuity', 'Resilience and sustainability'] },
        { icon: 'Leaf', title: 'Green Logistics', text: 'Transformation programs that reduce the environmental impact of logistics operations, improve resource use and create sustainable value.', bullets: ['Carbon footprint and emission reduction', 'Energy and resource efficiency', 'Sustainable operations roadmap'] },
        { icon: 'PackageSearch', title: 'Commodity Trading & Geopolitical Analysis', text: 'Logistics-focused assessment of commodity flows, trade corridors and geopolitical risks.', bullets: ['Trade corridors', 'Risk and scenario analysis', 'Commodity flow assessment'] },
      ],
      training: {
        eyebrow: 'Corporate and individual training',
        title: 'Training Programs',
        intro: 'Training topics grounded in field experience and adaptable to the needs of organizations and professionals.',
        items: [
          'Inventory Management',
          'Warehouse Management',
          'Warehouse Management Systems',
          'Warehouse Processes & Operational Efficiency',
          'Accurate Stock and Inventory Management & Counts',
          'Forklift Operating Rules',
          'Understanding Corporate Strategies',
          'INCOTERMS 2020',
          'Leadership in Logistics Management',
          'Effective Team Building & Team Management',
          '5S Implementation Training',
          'Payment Methods in International Trade',
        ],
        distribution: {
          eyebrow: 'Training focus',
          title: 'Sectoral Distribution of Training',
          intro: 'The distribution of training experience across sectors reflects the concentration of warehousing, dispatch and operational needs.',
          items: [
            { label: 'UND', value: 50 },
            { label: 'Warehousing', value: 30 },
            { label: 'Automotive Warehousing', value: 15 },
            { label: 'Healthcare Warehousing', value: 5 },
          ],
        },
      },
    },
    experience: {
      eyebrow: 'Career journey',
      title: 'Strategic leadership grounded in operations',
      items: [
        { period: '2019 — Present', title: 'Strategy, operations, sales and thought leadership', organization: 'Göktürk Logistics · LogiRED · Loji TV · Independent work', text: 'Warehouse and logistics management, sales and marketing leadership, strategy and operations direction, consulting, training, authorship and speaking.' },
        { period: '2012 — 2019', title: 'Logistics Center & Operations Manager', organization: 'Istanbul', text: 'Bonded warehousing, pharmaceutical and raw material flows, warehouse and transport operations, 3PL management, HSSE, KPIs and process improvement.' },
        { period: '2011 — 2012', title: 'Logistics Warehouse & Operations Manager', organization: 'Tatko — Tatkap A.Ş.', text: 'Warehouse, budget, supplier, distribution, export, MIKRO automation and efficiency management.' },
        { period: '2007 — 2010', title: 'Bonded & Non-Bonded Warehouse Manager', organization: 'Horoz Logistics', text: 'Warehouse, customs, customer, budget, distribution, supply chain, WMS LV3 and inventory optimization.' },
        { period: '2007', title: 'Operations Manager — Konya Project', organization: 'Borusan Logistics', text: 'Gap assessment, process and standard setup, training, customer satisfaction and operational handover.' },
        { period: '2001 — 2007', title: 'Logistics Warehouse & Operations Manager', organization: 'Rynart International Transport', text: 'ISO, HACCP, VAS, inventory and order operations, import-export, bonded warehousing and distribution.' },
        { period: '1995 — 1999', title: 'Logistics Warehouse Supervisor', organization: 'Arena Computer', text: 'New warehouse and business launches, import-export, order, inventory, distribution and team development.' },
      ],
    },
    analyses: {
      eyebrow: 'Geopolitical analyses',
      title: 'Reading global developments through logistics and trade flows',
      intro: 'Geopolitical developments reshape not only maps, but also cost, lead time, route security, commodity flows and supply chain resilience.',
      topics: [
        { title: 'Trade Corridors', text: 'Operational and economic impact of changing sea, road, air and rail corridors.' },
        { title: 'Regional Risks', text: 'Impact of political, security and climate risks on routes, capacity and service continuity.' },
        { title: 'Energy & Commodity Flows', text: 'Connections between commodity markets, transport capacity, inventory strategy and international trade.' },
        { title: 'Disasters & Resilience', text: 'Impact on infrastructure, preparedness, alternative networks and rapid coordination scenarios.' },
      ],
    },
    research: {
      eyebrow: 'Logistics research',
      title: 'Turning field questions into measurable knowledge',
      intro: 'My research agenda focuses on real operational problems, next-generation logistics practices and the transformation needs of the sector.',
      topics: [
        { title: 'Warehouse & Inventory', text: 'Inventory accuracy, layout, capacity, order preparation and warehouse performance models.' },
        { title: 'Digitalization & Automation', text: 'The operational impact of WMS, ERP, data flow, automation and decision support systems.' },
        { title: 'Cost & Efficiency', text: 'Total cost, service level, resource utilization and operational value creation.' },
        { title: 'Sustainable Logistics', text: 'Environmental impact, resource efficiency and long-term operational resilience.' },
      ],
      bookTitle: 'Solved Case Analyses in Logistics Activities',
      bookText: 'A practice-oriented work that examines logistics problems through real operational logic, analysis and solution steps.',
    },
    media: {
      eyebrow: 'Media and press',
      title: 'Sharing knowledge on stage, on screen and across digital channels',
      intro: 'I contribute to a broader understanding of logistics through conferences, panels, television programs, university events and digital content.',
      events: [
        {
          date: '2026',
          title: 'The Situation of People with Disabilities in Disasters and the Istanbul Earthquake',
          place: 'Beykent University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2026-beykent-afetlerde-engelli-bireyler.png',
          imageAlt: 'Presentation on people with disabilities in disasters and the Istanbul earthquake at Beykent University',
        },
        {
          date: '2026',
          title: 'Logistics Workshop Opening',
          place: 'Soma Fatih Vocational High School — Manisa',
          role: 'Guest',
          image: '/images/events/2026-soma-fatih-mtal-lojistik-atolye-acilisi.png',
          imageAlt: 'Opening of the logistics workshop at Soma Fatih Vocational High School',
        },
        {
          date: '2026',
          title: 'Davutpaşa Campus Gathering',
          place: 'Yıldız Technical University — Istanbul',
          role: 'Participant',
          image: '/images/events/2026-yildiz-teknik-davutpasa.png',
          imageAlt: 'Gathering at Yıldız Technical University Davutpaşa Campus',
        },
        {
          date: '2026',
          title: 'Beykent University Gathering',
          place: 'Beykent University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2026-beykent-universitesi-bulusmasi.png',
          imageAlt: 'Gürkan Kavrazlı presenting at Beykent University',
        },
        {
          date: '2025',
          title: 'Istanbul Kent University Gathering',
          place: 'Istanbul Kent University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2025-istanbul-kent-universitesi.png',
          imageAlt: 'Istanbul Kent University event and participants',
        },
        {
          date: '2025',
          title: 'Sustainability and Green Logistics Activities',
          place: 'Beykent University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2025-beykent-surdurulebilirlik-yesil-lojistik.png',
          imageAlt: 'Sustainability and green logistics event at Beykent University',
        },
        {
          date: '2025',
          title: 'Soma Fatih Vocational High School Gathering',
          place: 'Soma Fatih Vocational High School — Manisa',
          role: 'Speaker',
          image: '/images/events/2025-soma-fatih-mtal-bulusmasi.png',
          imageAlt: 'Gathering at Soma Fatih Vocational High School',
        },
        {
          date: '2025',
          title: 'Göktürk Logistics Workshop',
          place: 'Göktürk Logistics — Istanbul',
          role: 'Instructor',
          image: '/images/events/2025-gokturk-lojistik-workshop.png',
          imageAlt: 'Participants at the Göktürk Logistics workshop',
        },
        {
          date: '2024',
          title: 'Automechanika Istanbul',
          place: 'TÜYAP Fair and Congress Center — Istanbul',
          role: 'Speaker',
          image: '/images/events/2024-automechanika-tuyap.png',
          imageAlt: 'Gürkan Kavrazlı presenting at Automechanika Istanbul',
        },
        {
          date: 'May 2024',
          title: 'Logistics Talks Instagram Live',
          place: 'Instagram live with Halit Kaya',
          role: 'Guest',
          image: '/images/events/2024-halit-kaya-instagram-canli.png',
          imageAlt: 'Announcement for the Logistics Talks Instagram live with Gürkan Kavrazlı and Halit Kaya',
          category: 'online',
          sortDate: '2024-05-31',
        },
        {
          date: '2024',
          title: 'Cancer-Free Life Association Event',
          place: 'KüçükÇiftlik Park — Istanbul',
          role: 'Participant',
          image: '/images/events/2024-kansersiz-yasam-dernegi.png',
          imageAlt: 'Cancer-Free Life Association event at KüçükÇiftlik Park',
        },
        {
          date: '2023',
          title: 'Maritime Students Association Gathering',
          place: 'Maritime Students Association — Antalya',
          role: 'Speaker',
          image: '/images/events/2023-denizci-ogrenciler-dernegi-antalya.png',
          imageAlt: 'Maritime Students Association gathering in Antalya',
        },
        {
          date: '2023',
          title: 'Disaster Logistics',
          place: 'Logitrans Fair — Istanbul',
          role: 'Speaker',
          image: '/images/events/2023-logitrans-afet-lojistigi.png',
          imageAlt: 'Disaster logistics session at the Logitrans Fair',
        },
        {
          date: '2023',
          title: 'Beykent University Gathering',
          place: 'Beykent University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2023-beykent-universitesi-bulusmasi.png',
          imageAlt: 'Participants at the Beykent University gathering',
        },
        {
          date: 'May 2022',
          title: 'New Trends in Logistics',
          place: 'Beykent University Hadımköy Campus — Istanbul',
          role: 'Speaker',
          image: '/images/events/2022-beykent-lojistikte-yeni-trendler.png',
          imageAlt: 'Announcement for the New Trends in Logistics event at Beykent University',
          category: 'online',
          sortDate: '2022-05-18',
        },
        {
          date: 'March 2022',
          title: 'Emerging Trends in Management',
          place: 'Manipal University Jaipur — Online',
          role: 'Speaker',
          image: '/images/events/2022-manipal-university-emerging-trends.png',
          imageAlt: 'Speakers at the Emerging Trends in Management event at Manipal University Jaipur',
          category: 'online',
          sortDate: '2022-03-24',
        },
        {
          date: 'March 2022',
          title: '1 Coffee 1 Logistics: Warehouse and Inventory Management',
          place: 'LogiRED — Maltepe, Istanbul',
          role: 'Speaker',
          image: '/images/events/2022-logired-bir-kahve-bir-lojistik.png',
          imageAlt: 'Announcement for 1 Coffee 1 Logistics on warehouse and inventory management',
          category: 'online',
          sortDate: '2022-03-03',
        },
        {
          date: '2022',
          title: 'Yaşar University Online Gathering',
          place: 'Yaşar University — Online',
          role: 'Speaker',
          image: '/images/events/2022-yasar-universitesi-online.png',
          imageAlt: 'Online logistics gathering at Yaşar University',
          category: 'online',
          sortDate: '2022-01-01',
        },
        {
          date: '2021',
          title: 'Young UND Academy 1st Graduation Ceremony',
          place: 'Istanbul University — Istanbul',
          role: 'Speaker',
          image: '/images/events/2021-genc-und-akademi-mezuniyet.png',
          imageAlt: 'Young UND Academy first graduation ceremony',
        },
        {
          date: 'April 2020',
          title: 'Logistics Society Instagram Live',
          place: 'Bandırma Onyedi Eylül University — Online',
          role: 'Speaker',
          image: '/images/events/2020-bandirma-instagram-canli-yayin.png',
          imageAlt: 'Announcement for the Bandırma Onyedi Eylül University Logistics Society Instagram live',
          category: 'online',
          sortDate: '2020-04-06',
        },
        {
          date: '2020',
          title: 'New Trends in Logistics',
          place: 'Bandırma Onyedi Eylül University — Balıkesir',
          role: 'Speaker',
          image: '/images/events/2020-bandirma-onyedi-eylul-bulusmasi.png',
          imageAlt: 'Logistics presentation at Bandırma Onyedi Eylül University',
        },
        {
          date: 'January 2020',
          title: 'Lead Case Manager Workshop',
          place: 'Congar Law & Consulting — Istanbul',
          role: 'Participant',
          image: '/images/events/2020-lider-vaka-yoneticisi-workshop.jpeg',
          imageAlt: 'Gürkan Kavrazlı and a participant at the Lead Case Manager Workshop meeting',
        },
        {
          date: 'December 2019',
          title: 'Logistics Summit',
          place: 'Abidin Nesimi Fatinoğlu High School — Istanbul',
          role: 'Speaker',
          image: '/images/events/2019-anfa-lojistik-zirvesi.jpg',
          imageAlt: 'Participants at the Logistics Summit at Abidin Nesimi Fatinoğlu High School',
        },
        {
          date: '2019',
          title: 'KLU Faculty of Applied Sciences Gathering',
          place: 'Kırklareli University — Kırklareli',
          role: 'Speaker',
          image: '/images/events/2019-klu-uygulamali-bilimler.png',
          imageAlt: 'Gathering at Kırklareli University Faculty of Applied Sciences',
        },
        {
          date: '2019',
          title: 'Akdeniz University Gathering',
          place: 'Akdeniz University — Antalya',
          role: 'Speaker',
          image: '/images/events/2019-akdeniz-universitesi.png',
          imageAlt: 'Participants at the Akdeniz University event',
        },
        {
          date: '2019',
          title: '3rd InTraders International Trade Congress',
          place: 'Sakarya University — Sakarya',
          role: 'Speaker',
          image: '/images/events/2019-intraders-international-conference.png',
          imageAlt: 'Gürkan Kavrazlı at the 3rd InTraders International Trade Congress',
        },
        {
          date: '2019',
          title: 'Afyon Kocatepe University Gathering',
          place: 'Afyon Kocatepe University — Afyonkarahisar',
          role: 'Speaker',
          image: '/images/events/2019-afyon-kocatepe-universitesi.png',
          imageAlt: 'Participants at the Afyon Kocatepe University event',
        },
        {
          date: 'April 2019',
          title: '3rd Career Days',
          place: 'Recep Tayyip Erdoğan University — Rize',
          role: 'Speaker',
          image: '/images/events/2019-3-kariyer-gunleri-rize.jpg',
          imageAlt: 'Group photo from the 3rd Career Days at Recep Tayyip Erdoğan University',
        },
        {
          date: 'April 2019',
          title: 'İŞKOLİK TV Program',
          place: 'Business Channel — Istanbul',
          role: 'Speaker',
          image: '/images/events/2019-iskolik-tv-business-channel.jpeg',
          imageAlt: 'Event and certificate photo from the İŞKOLİK TV Program on Business Channel',
        },
        {
          date: 'April 2019',
          title: 'Konya Logistics Summit',
          place: 'Necmettin Erbakan University — Konya',
          role: 'Speaker',
          image: '/images/events/2019-konya-lojistik-zirvesi.jpeg',
          imageAlt: 'Stage photo from the Konya Logistics Summit at Necmettin Erbakan University',
        },
        {
          date: 'March 2019',
          title: 'Professional Tactics from Industry Veterans III',
          place: 'Çağ University — Mersin',
          role: 'Speaker',
          image: '/images/events/2019-cag-universitesi-duayenlerden-mesleki-taktikler.jpeg',
          imageAlt: 'Gürkan Kavrazlı presenting at Professional Tactics from Industry Veterans III at Çağ University',
        },
        {
          date: 'April 2018',
          title: 'International Logistics Management & Career Planning',
          place: 'Beykent University — Istanbul',
          role: 'Panelist / Speaker',
          image: '/images/events/2018-uluslararasi-lojistik-yonetimi-kariyer-planlamasi.jpeg',
          imageAlt: 'Gürkan Kavrazlı presenting at the International Logistics Management and Career Planning event',
        },
        {
          date: '2016',
          title: 'Samandıra Vocational High School Logistics Gathering',
          place: 'Samandıra Vocational High School — Istanbul',
          role: 'Speaker',
          image: '/images/events/2016-samandira-mtal.png',
          imageAlt: 'Logistics gathering at Samandıra Vocational High School',
        },
      ],
    },
    lifestyle: {
      eyebrow: 'Lifestyle',
      title: 'Moments from Life',
      intro: 'Lifestyle content, experiences and personal stories will be shared on this page.',
      comingSoon: 'New content is coming soon.',
    },
    references: {
      eyebrow: 'References and sector experience',
      title: 'Experience across industries with different operational realities',
      intro: 'Experience is not only measured in years; it is the ability to understand different products, customers and service models and turn them into the right operating system.',
      organizationsTitle: 'Organizations and Training References',
      organizationsIntro: 'Organizations and brands engaged through consulting, training, collaboration and industry initiatives.',
      sectors: ['Automotive', 'Consumer Durables', 'Pharmaceuticals', 'High-Tech Materials', 'Nonwoven Products', 'Medical Devices', 'Computer & Technology', 'International Transport'],
      standards: ['ISO 9001', 'ISO 14001', 'HACCP', 'TAPA', '5S', 'POP', 'HSSE', 'Six Sigma'],
    },
    socialResponsibility: {
      eyebrow: 'Social responsibility',
      title: 'I see knowledge sharing as part of professional responsibility',
      items: [
        'Voluntary meetings with students at vocational schools and universities',
        'CV consulting, internship and workplace support',
        'Mentoring for university students, graduates and professionals',
        'Master’s and doctoral thesis coaching',
        'Contribution to disaster awareness through AKUT, AFAD and MAG AME volunteering',
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Let’s connect for a project, training program or speaking engagement',
      intro: 'Briefly describe your need. Your message will reach me directly through the secure contact center.',
      email: 'gurkankavrazli@gmail.com',
      phone: '+90 542 315 7098',
      location: 'Istanbul, Türkiye',
      form: {
        name: 'Full name',
        email: 'Email',
        company: 'Company / Organization',
        subject: 'Subject',
        message: 'Your message',
        consent: 'I consent to the processing of the information I share for communication purposes.',
        submit: 'Send message',
        sending: 'Sending…',
        success: 'Your message has been sent successfully. You will receive a response as soon as possible.',
        error: 'The message could not be sent. Please try again later or send an email directly.',
      },
    },
    blog: {
      eyebrow: 'Blog / Insights',
      title: 'Notes on logistics, supply chain and global trade',
      intro: 'Field observations, research notes, event content and strategic perspectives.',
      empty: 'There are no published posts yet.',
      fallbackNotice: 'The content below is shown as introductory content until Supabase is connected.',
      categories: { all: 'All' },
    },
    footer: {
      statement: 'Adding value to the future of logistics through strategy, operations and knowledge sharing.',
      rights: 'All rights reserved.',
      admin: 'Admin login',
    },
  },
}
